module.exports = (prefix) => ({
  id: `${prefix} Unknown`,
  type: 'input',
  question: 'What did you see in the video?',
});
